<app-modal [modalTitleText]="headerText" [cancelButtonText]="closeText" [primaryButtonEnabled]="false" (cancelButtonAction)="closeModal()">
  <app-terms-of-service [footerStickyEnabled]="false" modal-content></app-terms-of-service>
</app-modal>
